
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('overview', {
      data: 'closingstrength'
    })
  } // computed
}; // export default
